import { useEffect, useRef, useState } from "react";
import type { ShieldWallOutcome } from "../shieldwall/components/ShieldWallWidget";

interface Props {
  open: boolean;
  outcome: ShieldWallOutcome | null;
  onSend: (note: string) => void;
  onCancel: () => void;
}

export default function ReportDialog({ open, outcome, onSend, onCancel }: Props) {
  const dlg = useRef<HTMLDialogElement>(null);
  const [note, setNote] = useState("");

  useEffect(() => {
    const el = dlg.current;
    if (!el) return;
    if (open && !el.open) {
      setNote("");
      el.showModal();
    }
    if (!open && el.open) el.close();
  }, [open]);

  return (
    <dialog
      className="sheet"
      ref={dlg}
      aria-labelledby="report-h"
      onCancel={(e) => {
        e.preventDefault();
        onCancel();
      }}
    >
      <form
        method="dialog"
        className="sheet__in"
        onSubmit={(e) => {
          e.preventDefault();
          onSend(note.trim());
        }}
      >
        <h2 className="sheet__h" id="report-h">
          Tell us it got you wrong
        </h2>
        <p className="sheet__p">
          One tap sends the check&rsquo;s score and reason codes. Nothing you typed in the form
          goes with it.
        </p>
        <label className="label" htmlFor="reportWhat">
          What happened <span className="label__note">optional</span>
        </label>
        <input
          className="input"
          id="reportWhat"
          maxLength={120}
          placeholder="On hotel wifi, no VPN"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        <div className="sheet__acts">
          <button className="btn btn--ghost" type="button" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn--primary" type="submit">
            Send report
          </button>
        </div>
        <p className="sheet__ref">
          {outcome
            ? `Score ${outcome.score} · ${outcome.reasonCodes.join(", ") || "no reason codes"}`
            : "No check result recorded"}
        </p>
      </form>
    </dialog>
  );
}
